module.exports = __webpack_public_path__ + "static/img/2.529ad76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/sky101/2.png
// module id = 65Qd
// module chunks = 1